
import { defineComponent, PropType } from "vue";
import moment from "moment";
import { Message } from "@/controller/chat";

export default defineComponent({
  name: "MessageBalloon",

  inheritAttrs: false,

  props: {
    message: {
      type: Object as PropType<Message>,
      required: true
    }
  },

  computed: {
    containerClasses(): string {
      const baseClass = "message-balloon";
      const classes = [baseClass];

      if (this.isMe) {
        classes.push(`${baseClass}--is-me`);
      }

      return classes.join(" ");
    },

    isMe(): boolean {
      return this.message.isFromCustomer;
    },

    sentAt(): string {
      return moment(this.message.date).fromNow();
    },

    hasImages(): boolean {
      return !!this.message.images;
    }
  },

  methods: {
    emitClickImage(image: string) {
      this.$emit("click:image", image);
    }
  }
});
